import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-050b597e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-table" }
const _hoisted_2 = { class: "payment-table__title center" }
const _hoisted_3 = { class: "payment-table__title-text" }
const _hoisted_4 = { class: "payment-table__content" }
const _hoisted_5 = { class: "payment-table__item-title third-color" }
const _hoisted_6 = { class: "payment-table__item-value" }
const _hoisted_7 = {
  key: 0,
  class: "payment-table__item"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "payment-table__item-title" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "payment-table__item-value" }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "center mt--16"
}

import { onMounted, Ref, ref } from 'vue';
import { useAppStore } from '@/store/modules/app';

type TableItemsType = { title: string; value: string }[];

type PaymentDataType = {
  categoryId: number;
  title: string;
  items: TableItemsType;
  showAllTable: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PassportTable',
  props: {
    tableData: {},
    showAllTable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const prepareTableData = (item: PaymentDataType): TableItemsType => {
  return item.showAllTable ? item.items : [...item.items].slice(0, 6);
};

const paymentDataByCategories: Ref<PaymentDataType[]> = ref([]);

onMounted(() => {
  if (props.tableData) {
    props.tableData.forEach((el, index) => {
      paymentDataByCategories.value.push({
        categoryId: index,
        title: el.title,
        items: el.items,
        showAllTable: props.showAllTable,
      });
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentDataByCategories.value, (category) => {
      return (_openBlock(), _createElementBlock("div", {
        key: category.categoryId,
        class: "mb--30"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(category.title), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prepareTableData(category), (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "payment-table__item"
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(Array.isArray(item.value)
                  ? item.value.map(el => el.name).join(', ')
                  : item.value === ''
                    ? '-'
                    : item.value), 1)
              ]))
            }), 128)),
            (
              _unref(useAppStore)().getWindowWidth() > 600 &&
              prepareTableData(category).length % 2 === 1
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
              : _createCommentVNode("", true)
          ])
        ]),
        (category.items.length > 6)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_base_button, {
                text: category.showAllTable ? 'Свернуть' : 'Развернуть',
                height: "36",
                "style-type": "coloredBorder",
                width: "186",
                onClick: ($event: any) => (category.showAllTable = !category.showAllTable)
              }, null, 8, ["text", "onClick"])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})